import { AutocompleteInput, Edit, SimpleForm, TextInput, maxLength } from 'react-admin';
import { RegionResource } from '../../Entities/Region';
import EditToolbar from '../../Components/EditToolbar';
import { ReactElement } from 'react';
import { CURRENCY_CODE_CHOICES } from './utils';

export default function RegionEdit(): ReactElement {
  return (
    <Edit<RegionResource> mutationMode="pessimistic">
      <SimpleForm toolbar={<EditToolbar />}>
        <TextInput label="Name" source="attributes.name" validate={maxLength(100)} />
        <AutocompleteInput
          choices={CURRENCY_CODE_CHOICES}
          label="Currency Code"
          source="attributes.currency_code"
        />
        <TextInput label="Domain" source="attributes.domain" validate={maxLength(50)} />
      </SimpleForm>
    </Edit>
  );
}
